// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OfficeFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OfficeFilledIcon" ref={forwardedRef} {...props}>
      <path d="M16 17.5h-4.75V14h-2.5v3.5H4v-14a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM7.125 7.77h-1.75v1.25h1.75zm2 0v1.25h1.75V7.77zm1.75-3.27h-1.75v1.25h1.75zm-5.5 0v1.25h1.75V4.5zm1.75 6.541h-1.75v1.25h1.75zm2 0v1.25h1.75v-1.25zm5.5-3.27h-1.75v1.25h1.75zM12.875 4.5v1.25h1.75V4.5zm1.75 6.541h-1.75v1.25h1.75z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const OfficeFilledIcon = /* @__PURE__ */ Object.assign(
  OfficeFilledIconComponent,
  { displayName: 'OfficeFilledIcon' },
);
